import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

export const login = ({ mode, userKind, loginInfo }) => {
    // console.log("api login:) mode[", mode, "], userKind[", userKind, "], loginInfo => ", loginInfo);
    // console.log("api login:) reqeust rest api path[", `/user/login?mode=${mode}`, "]");

    return axiosClient.post(`/user/login?mode=${mode}`, { // payload 형식
        userID: loginInfo.userID,
        userPW: loginInfo.password,
        isAutoLogin: loginInfo.isAutoLogin,
        userKind
    }, options);
}

export const login_without_pw = ({ mode, userKind, loginInfo }) => {
    console.log("api login without pw:) mode[", mode, "], userKind[", userKind, "], loginInfo => ", loginInfo);
    // console.log("api login without pw:) reqeust rest api path[", `/user/login?mode=${mode}&kind=local-login`, "]");

    return axiosClient.post(`/user/login?mode=${mode}&kind=local-login`, { // payload 형식
        userID: loginInfo.userID,
        // userPW: loginInfo.password,
        // isAutoLogin: loginInfo.isAutoLogin,
        userKind
    }, options);
}

export const login_local_auto = ({ userSeq }) => {
    console.log("api login local auto:) userSeq[", userSeq, "]");
    console.log("api login local auto:) reqeust rest api path[", `/local/userAutoLogin`, "]");

    return axiosClient.post(`/local/userAutoLogin`, { // payload 형식
        userSEQ: userSeq
    }, options);
}

export const auto_login = ({ mode, userKind, tokenKey }) => {
    console.log("api auto login:) mode[", mode, "], userKind[", userKind, "], tokenKey[", tokenKey, "]");

    return axiosClient.post(`/user/login/auto?kind=login&mode=${mode}`, { // payload 형식
        tokenKey,
        userKind
    }, options);
}

export const login_guest = ({ mode, userKind, guestLoginKey, loginInfo }) => {
    console.log("api login guest:) mode[", mode, "], userKind[", userKind, "], guestLoginKey[", guestLoginKey, "], loginInfo => ", loginInfo);
    console.log("api login guest:) reqeust rest api path[", `/user/login/auto?kind=guest&mode=${mode}`, "]");

    return axiosClient.post(`/user/login/auto?kind=guest&mode=${mode}`, { // payload 형식
        guestLoginKey,
        userKind
    }, options);
}

export const login_qrcode = ({ mode, userSeq, userKind, loginInfo }) => {
    console.log("api login qrcode:) mode[", mode, "], userSeq[", userSeq, "], userKind[", userKind, "], loginInfo => ", loginInfo);
    console.log("api login qrcode:) reqeust rest api path[", `/user/login/auto?kind=qr-login&mode=${mode}`, "]");

    return axiosClient.post(`/user/login/auto?kind=qr-login&mode=${mode}`, { // payload 형식
        userSEQ: userSeq,
        userKind
    }, options);
}

export const login_through_notification = ({ mode, userKind, broadcastKey, loginInfo }) => {
    console.log("api login through notification:) mode[", mode, "], userKind[", userKind, "], broadcastKey[", broadcastKey, "], loginInfo => ", loginInfo);
    console.log("api login through notification:) reqeust rest api path[", `/user/login/extra?kind=login-through-key&mode=${mode}`, "]");

    return axiosClient.post(`/user/login/extra?kind=login-through-key&mode=${mode}`, {
        userID: loginInfo.userID,
        userPW: loginInfo.password,
        isAutoLogin: loginInfo.isAutoLogin,
        broadcastKey,
        userKind
    }, options)
}

export const login_smart_tv = ({ mode, userSeq, userKind, liveSeq }) => {
    console.log("api login smart tv:) mode[", mode, "], userSeq[", userSeq, "], userKind[", userKind, "], liveSeq[", liveSeq, "]");
    // console.log("api login smart tv:) reqeust rest api path[", `/user/login/auto-all?kind=smart-tv-login&mode=${mode}`, "]");

    let protocol = window.location.protocol;
    if (ConstData.IS_LOCAL_VERSION && protocol === "http:") {
        let newRestApiUrl = ConstData.REST_API_HOST_ADD;
        newRestApiUrl = newRestApiUrl.replace("https:", "http:");
        newRestApiUrl = newRestApiUrl.replace(":8001", ":8000");

        console.log("api login smart tv:) use new rest api url!!! - newRestApiUrl[", newRestApiUrl, "]");
        console.log("api login smart tv:) reqeust rest api path[", `${newRestApiUrl}/user/login/auto-all?kind=smart-tv-login&mode=${mode}`, "]");

        return axiosClient.post(`${newRestApiUrl}/user/login/auto-all?kind=smart-tv-login&mode=${mode}`, { // payload 형식
            userSEQ: userSeq,
            liveSEQ: liveSeq,
            userKind
        }, options);
    } else {
        let originalRestApiUrl = ConstData.REST_API_HOST_ADD;
        console.log("api login smart tv:) use original rest api url!!! - originalRestApiUrl[", originalRestApiUrl, "]");
        console.log("api login smart tv:) reqeust rest api path[", `${originalRestApiUrl}/user/login/auto?kind=smart-tv-login&mode=${mode}`, "]");

        return axiosClient.post(`/user/login/auto?kind=smart-tv-login&mode=${mode}`, { // payload 형식
            userSEQ: userSeq,
            liveSEQ: liveSeq,
            userKind
        }, options);
    }
}

export const login_group_smart_tv = ({ mode, userSeq, userKind, liveSeq, list_member, groupSeq, groupName }) => {
    console.log("api login group smart tv:) mode[", mode, "], userSeq[", userSeq, ", userKind[", userKind, "]");
    console.log("api login group smart tv:) liveSeq[", liveSeq, "], list_member => ", list_member);
    console.log("api login group smart tv:) groupSeq[", groupSeq, "], groupName[", groupName, "]");

    let protocol = window.location.protocol;
    if (ConstData.IS_LOCAL_VERSION && protocol === "http:") {
        let newRestApiUrl = ConstData.REST_API_HOST_ADD;
        newRestApiUrl = newRestApiUrl.replace("https:", "http:");
        newRestApiUrl = newRestApiUrl.replace(":8001", ":8000");

        console.log("api login group smart tv:) use new rest api url!!! - newRestApiUrl[", newRestApiUrl, "]");
        console.log("api login group smart tv:) reqeust rest api path[", `${newRestApiUrl}/user/login/auto-all?kind=group-smart-tv-login&mode=${mode}`, "]");

        return axiosClient.post(`${newRestApiUrl}/user/login/auto-all?kind=group-smart-tv-login&mode=${mode}`, { // payload 형식
            userSEQ: groupSeq,
            liveSEQ: liveSeq,
            userKind
        }, options);
    } else {
        let originalRestApiUrl = ConstData.REST_API_HOST_ADD;
        console.log("api login group smart tv:) use original rest api url!!! - originalRestApiUrl[", originalRestApiUrl, "]");
        console.log("api login group smart tv:) reqeust rest api path[", `${originalRestApiUrl}/user/login/auto?kind=group-smart-tv-login&mode=${mode}`, "]");

        return axiosClient.post(`/user/login/auto?kind=group-smart-tv-login&mode=${mode}`, { // payload 형식
            userSEQ: groupSeq,
            liveSEQ: liveSeq,
            userKind
        }, options);
    }
}

export const logout = ({ mode, userSeq, liveSeq, isClickLogout }) => {
    console.log("api logout:) mode[", mode, "], userSeq[", userSeq, "], liveSeq[", liveSeq, "], isClickLogout[", isClickLogout, "]");
    // console.log("api logout:) reqeust rest api path[", `/user/${userSeq}/logout?mode=${mode}`, "]");

    let url = `/user/${userSeq}/logout?mode=${mode}`;
    if (liveSeq >= 0) {
        url += `&liveSEQ=${liveSeq}`;
    }

    if (isClickLogout) {
        url += `&isClickLogout=${isClickLogout}`;
    }

    console.log("api logout:) reqeust rest api path[", `${url}`, "]");

    /* if (liveSeq >= 0) {
        console.log("api logout:) reqeust rest api path[", `/user/${userSeq}/logout?mode=${mode}&liveSEQ=${liveSeq}`, "]");

        return axiosClient.delete(`/user/${userSeq}/logout?mode=${mode}&liveSEQ=${liveSeq}`, options);
    } else {
        console.log("api logout:) reqeust rest api path[", `/user/${userSeq}/logout?mode=${mode}`, "]");

        return axiosClient.delete(`/user/${userSeq}/logout?mode=${mode}`, options);
    } */

    return axiosClient.delete(url, options);
}

export const force_logout = ({ mode, userSeq }) => {
    return axiosClient.delete(`/user/${userSeq}/logout?kind=force-logout&mode=${mode}`, options);
}

export const notify_logout_to_android_app = ({ userSeq }) => {
    console.log("api notify logout to android app:) userSeq[", userSeq, "]");
    console.log("api notify logout to android app:) reqeust rest api path[", `/user/${userSeq}/logout?mode=android-app`, "]");

    return axiosClient.delete(`/user/${userSeq}/logout?mode=android-app`, options);
}

export const request_mixed_class_login = ({ tokenKey, mixedClassSeq, userKind }) => {
    /* return axiosClient.post(`/user/login/auto?kind=mixed-class-check&mode=web`, { // payload 형식
        tokenKey,
        userKind
    }); */

    return axiosClient.post(`/user/login/auto?kind=mixed-class-check&mode=web`, { // payload 형식
        mixedClassSEQ: mixedClassSeq,
        userKind
    }, options);
}

export const idcheck = ({ userID, userKind }) => {
    return axiosClient.get(`/user?kind=check-ID&userID=${userID}&userKind=${userKind}`, options); // query 형식
}

export const send_phone_check = ({ phoneNumber }) => {
    return axiosClient.post(`/user/certi?kind=phone`, { // query & payload 형식
        userPN: phoneNumber
    }, options);
}

export const send_email_check = ({ userEmail }) => {
    return axiosClient.post(`/user/certi?kind=email`, { // query & payload 형식
        userEmail: userEmail
    }, options);
}

export const confirm_phone_check = ({ certiCodeSeq, confirmNumber }) => {
    console.log("api confirm phone check:) certiCodeSeq[", certiCodeSeq, "], confirmNumber[", confirmNumber, "]")
    console.log("api confirm phone check:) reqeust rest api path[", `/user/certi?kind=phone`, "]");

    return axiosClient.put(`/user/certi?kind=phone`, {
        certiSEQ: certiCodeSeq,
        certi_code: confirmNumber
    }, options);
}

export const confirm_email_check = ({ certiCodeSeq, confirmNumber }) => {
    return axiosClient.put(`/user/certi?kind=email`, {
        certiSEQ: certiCodeSeq,
        certi_code: confirmNumber
    }, options);
}

export const regist_user = ({ userID, password, userNickname, userEmail, phoneNumber, userProfile, profileImgUrl, userExtraCode, userKind, userType }) => {
    return axiosClient.post(`/user`, { // payload 형식
        userID: userID,
        userPN: phoneNumber,
        userEmail: userEmail,
        userNickname: userNickname,
        userPW: password,
        userProfile: userProfile,
        userProfileIMG: profileImgUrl,
        userExtraCode: userExtraCode === "" ? null : userExtraCode,
        userKind: userKind,
        userType: userType
    }, options);
}

export const update_user_info = ({ mode, userSeq, phoneNumber, userEmail, password, userNickname, userProfile, userExtraCode, profileImgUrl }) => {
    return axiosClient.put(`/user/${userSeq}?mode=${mode}`, { // param & query & payload 형식
        userPN: phoneNumber === undefined ? null : phoneNumber,
        userEmail: userEmail === undefined ? null : userEmail,
        userNickname: userNickname === undefined ? null : userNickname,
        userPW: password === undefined ? null : password,
        userProfile: userProfile === undefined ? null : userProfile,
        userExtraCode: (userExtraCode === undefined || userExtraCode === "") ? null : userExtraCode,
        userProfileIMG: profileImgUrl === undefined ? null : profileImgUrl
    }, options);
}

export const search = ({ userSeq, keyWord }) => {
    return axiosClient.get(`/user?kind=search&userSEQ=${userSeq}&keyword=${keyWord}`, options);
}

export const search_my_id = ({ userPN, userKind }) => {
    return axiosClient.post(`/user/help?kind=search-myID`, {
        userPN: userPN,
        userKind: userKind
    }, options);
}

export const compare_info = ({ userPN, userID, userKind }) => {
    return axiosClient.post(`/user/help?kind=compare`, {
        userPN: userPN,
        userID: userID,
        userKind: userKind
    }, options);
}

export const reset_my_pw = ({ userID, userPW }) => {
    return axiosClient.put(`/user/help?kind=reset-pw`, {
        userID: userID,
        userPW: userPW
    }, options);
}

// 260728 ClassMonitor 접속 프로토콜에 맞춰 HTTP(index_all:8000)와 HTTPS(index:8001)를 구분한다.
const getClassMonitorRestApiUrl = () => {
    const isHttp = window.location.protocol === "http:";
    try {
        const apiUrl = new URL(ConstData.REST_API_HOST_ADD);
        apiUrl.protocol = isHttp ? "http:" : "https:";
        apiUrl.port = isHttp ? "8000" : "8001";
        return apiUrl.origin;
    } catch (err) {
        let apiUrl = ConstData.REST_API_HOST_ADD.replace(/^https?:/i, isHttp ? "http:" : "https:");
        apiUrl = apiUrl.replace(/:\d+$/, isHttp ? ":8000" : ":8001");
        return apiUrl;
    }
};

// 20260812 클래스 목록을 조회하기 전에 로컬 서버의 클래스 모니터 사용 허가를 확인한다.
export const get_class_monitor_access = () => (
    axiosClient.get(`${getClassMonitorRestApiUrl()}/user/class-monitor/access`)
);

// 20260813 선생님의 로컬 클래스 설정 화면에서 클래스 모니터 사용 상태를 조회한다.
export const get_class_monitor_use = (liveSeq, teacherSeq) => (
    axiosClient.get(`${getClassMonitorRestApiUrl()}/user/class-monitor/live/${liveSeq}/use`, {
        params: { teacherSeq }
    })
);

// 20260813 선생님의 클래스 모니터 ON/OFF 설정을 별도 API로 저장한다.
export const update_class_monitor_use = (liveSeq, teacherSeq, classMonitorUseYN) => (
    axiosClient.put(`${getClassMonitorRestApiUrl()}/user/class-monitor/live/${liveSeq}/use`, {
        teacherSeq,
        classMonitorUseYN
    })
);

// 260728 현재 사용자가 모니터링할 수 있는 진행 중 클래스를 조회한다.
export const get_class_monitor_lives = () => (
    axiosClient.get(`${getClassMonitorRestApiUrl()}/user/class-monitor/lives`) // 260728 SmartTV처럼 별도 사용자 로그인 없이 클래스 목록을 조회한다.
);

// 260728 선택한 클래스의 독립 ClassMonitor 세션을 발급받는다.
export const create_class_monitor_session = liveSeq => (
    axiosClient.post(`${getClassMonitorRestApiUrl()}/user/class-monitor/session`, { liveSeq }) // 260728 선택한 클래스 기준으로 독립 모니터 세션을 생성한다.
);

// 260728 그룹 재설정 시 페이지를 새로고침하지 않고 최신 클래스 정보를 조회한다.
export const get_class_monitor_live = liveSeq => (
    axiosClient.get(`${getClassMonitorRestApiUrl()}/user/class-monitor/live/${liveSeq}`)
);
